<template>
<div v-html="getPopup(props.item)"></div>
</template>

<script setup>
import { defineProps } from 'vue';
import { getAPRSSymbolImageClass } from '../js/aprssymbols.js'
import { formatedRTTime } from '../js/tmlf.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
    item: Object,
 })

// const data = ref()

function getPopup(item) {

    let result = ''
    result = result + '<div class="d-flex flex-wrap">'
    if (getAPRSSymbolImageClass(item.symboltable + item.symbolcode, 24)) {
        result = result + '<div class="px-1 d-flex"><span class="fw-semibold"><i class="' + getAPRSSymbolImageClass(item.symboltable + item.symbolcode, 24) + '"></i></span></div>'
    }
    // result = result + '<div class="px-2"><span class="fw-semibold">#{{ fetchResult.array.length-itemKey }}</span></div>'
    result = result + '<div class="p-1 d-flex"><span class="fw-semibold">' + formatedRTTime(item.receivedTime) + '</span></div>'
    // result = result + '<div class="p-1 text-nowrap"><span class="fw-semibold">'+item.origpacket+'</span></div>'

    if (item.type) { result = result + '<div class="p-1 d-flex">'+t('Type:')+'&nbsp;<span class="fw-semibold">' + item.type + '</span></div>' }
    if (item.format) { result = result + '<div class="p-1 d-flex">'+t('Format:')+'&nbsp;<span class="fw-semibold">' + item.format + '</span></div>' }
    if (item.symboltable && item.symbolcode) { result = result + '<div class="p-1">'+t('Symbol:')+'&nbsp;<span class="fw-semibold">' + item.symboltable + item.symbolcode + '</span></div>' }
    if (item.destCallsign) { result = result + '<div class="p-1">'+t('Dest. Callsign:')+'&nbsp;<span class="fw-semibold">' + item.destCallsign + '</span></div>' }
    if (item.digipeaters.length) {
        result = result + '<div class="p-1 d-flex">'
        for (let i in item.digipeaters) {
            result = result + '<span>' + item.digipeaters[i].callsign + '</span>'
            i != (item.digipeaters.length - 1) ? result = result + ',' : result = result + ''
        }
        result = result + '</div>'
    }
    if (item.comment) { result = result + '<div class="p-1">'+t('Comment:')+'&nbsp;<span class="fw-semibold">' + item.comment + '</span></div>' }
    if (item.messageId) { result = result + '<div class="p-1">'+t('Message Id:')+'&nbsp;<span class="fw-semibold">' + item.messageId + '</span></div>' }
    if (item.message) { result = result + '<div class="p-1">'+t('Message:')+'&nbsp;<span class="fw-semibold">' + item.message + '</span></div>' }

    if (item.latitude) { result = result + '<div class="p-1">'+t('Latitude:')+'&nbsp;<span class="fw-semibold">' + item.latitude.toFixed(5) + '</span></div>' }
    if (item.longitude) { result = result + '<div class="p-1">'+t('Longitude:')+'&nbsp;<span class="fw-semibold">' + item.longitude.toFixed(5) + '</span></div>' }
    if (item.speed) { result = result + '<div class="p-1">'+t('Speed:')+'&nbsp;<span class="fw-semibold">' + item.speed.toFixed(0) + ' km/h</span></div>' }
    if (item.course) { result = result + '<div class="p-1">'+t('Course:')+'&nbsp;<span class="fw-semibold">' + item.course.toFixed(0) + '  °</span></div>' }
    if (item.altitude) { result = result + '<div class="p-1">'+t('Altitude:')+'&nbsp;<span class="fw-semibold">' + item.altitude.toFixed(0) + ' m</span></div>' }
    if (item.distance) { result = result + '<div class="p-1">'+t('Dist. From Last Pos.:')+'&nbsp;<span class="fw-semibold">' + (item.distance / 1000).toFixed(2) + ' km</span></div>' }

    if (item.wx) {
        if (item.wx.temp) { result = result + '<div class="p-1">'+t('Temp:')+'&nbsp;<span class="fw-semibold">' + item.wx.temp + '  °C</span></div>' }
        if (item.wx.pressure) { result = result + '<div class="p-1">'+t('Pressure:')+'&nbsp;<span class="fw-semibold">' + item.wx.pressure + ' hPa</span></div>' }
        if (item.wx.humidity) { result = result + '<div class="p-1">'+t('Humidity:')+'&nbsp;<span class="fw-semibold">' + item.wx.humidity + ' %</span></div>' }
        if (item.wx.rain_1h) { result = result + '<div class="p-1">'+t('Rain 1h:')+'&nbsp;<span class="fw-semibold">' + item.wx.rain_1h + ' mm</span></div>' }
        if (item.wx.rain_24h) { result = result + '<div class="p-1">'+t('Rain 24h:')+'&nbsp;<span class="fw-semibold">' + item.wx.rain_24h + ' mm</span></div>' }
        if (item.wx.rain_midnight) { result = result + '<div class="p-1">'+t('Rain Midnight:')+'&nbsp;<span class="fw-semibold">' + item.wx.rain_midnight + ' mm</span></div>' }
        if (item.wx.wind_direction) { result = result + '<div class="p-1">'+t('Wind Direction:')+'&nbsp;<span class="fw-semibold">' + item.wx.wind_direction + '  °</span></div>' }
        if (item.wx.wind_gust) { result = result + '<div class="p-1">'+t('Wind Gust:')+'&nbsp;<span class="fw-semibold">' + item.wx.wind_gust + ' km/h</span></div>' }
        if (item.wx.wind_speed) { result = result + '<div class="p-1">'+t('Wind Speed:')+'&nbsp;<span class="fw-semibold">' + item.wx.wind_speed + ' km/h</span></div>' }
    }

    result = result + '</div>'

    // console.log(result)
    return result
} 

</script>

<i18n>
    {
      "pl": {
        "Type:": "Typ:",
        "Format:": "Format:",
        "Symbol:": "Symbol:",
        "Dest. Callsign:": "Adres Przezn.:",
        "Comment:": "Komentarz:",
        "Message Id:": "Nr Wiad.:",
        "Message:": "Wiadomość:",
        "Latitude:": "Szerokość:",
        "Longitude:": "Długość:",
        "Speed:": "Prędkość:",
        "Course:": "Kurs:",
        "Altitude:": "Wysokość:",
        "Dist. From Last Pos.:": "Dystans od Poprz. Poz.",
        "Temp:": "Temp:",
        "Pressure:": "Ciśnienie:",
        "Humidity:": "Wilgotność:",
        "Rain 1h:": "Deszcz 1 godz.:",
        "Rain 24h:": "Deszcz 24 godz.:",
        "Rain Midnight:": "Deszcz od Północy:",
        "Wind Direction:": "Wiatr Kierunek:",
        "Wind Gust:": "Wiatr Porywy:",
        "Wind Speed:": "Wiatr Prędkość:",
      }
    }
</i18n>
